

import actionCreator from '../common/actionObjectCreator';
import submitData from '../common/postData';

import {getUser, setUser, removeUser} from '../helpers/userStorage';

export const actionDescriptor = "home/";

const createAction = actionCreator(actionDescriptor);

const INITIALIZE = createAction("INITIALIZE");
const SIGN_OUT = createAction("SIGN_OUT");
const LOGIN = createAction("LOGIN");
const CLEAR_LOGIN = createAction("CLEAR_LOGIN");
const REGISTER_USER = createAction("REGISTER_USER");
const GET_IS_LOGGED_IN = createAction("GET_IS_LOGGED_IN");



export function initialize() {

    return {
        type: INITIALIZE.fulfilled
    };
}

export function signOut(onComplete) {

    return {
        type: SIGN_OUT.fulfilled,
        onComplete
    };
}

export function login(email, password) {

    return dispatch => {

        submitData('users/authenticate', { email, password }, LOGIN, dispatch, false, {}, 'POST', true, 1000);
    }
}

export function clearLogin() {

    return {
        type: CLEAR_LOGIN.default
    }
}

export function loginGoogle(token,onLoggedIn) {

    return dispatch => {

        submitData('users/authenticateGoogle', { token }, LOGIN, dispatch, false, {onLoggedIn}, 'POST', true, 1000);
    }
}

export function loginFacebook(token,signedRequest,onLoggedIn) {

    return dispatch => {

        submitData('users/authenticateFacebook', { token,signedRequest }, LOGIN, dispatch, false, {onLoggedIn}, 'POST', true, 1000);
    }
}

export function register(email, fullName, password, onRegistered) {

    return dispatch => {

        submitData('users/register', { email, password, fullName }, REGISTER_USER, dispatch, false, { onRegistered }, 'POST', true, 1000);
    }
}

export function registerGoogle(token, onRegistered) {

    return dispatch => {

        submitData('users/registerGoogle', { token }, REGISTER_USER, dispatch, false, { onRegistered }, 'POST', true, 1000);
    }
}

export function isLoggedIn() {

    return dispatch => {

        submitData('users/isLoggedIn', null, GET_IS_LOGGED_IN, dispatch, true, {}, 'GET');
    }
}

const reducer = (state = {}, action) => {

    var ret;

    switch (action.type) {
        case INITIALIZE.fulfilled:
            ret = Object.assign({}, state);

            let user = getUser();

            if (user) {
                ret.user = user;
            }

            return ret;
        case SIGN_OUT.fulfilled:
            ret = Object.assign({}, state);
            ret.user = null;
            removeUser();

            action.onComplete && action.onComplete();

            return ret;
        case CLEAR_LOGIN.default:
            ret = Object.assign({}, state);
            ret.loginErrorMessage = null;
            ret.registerErrorMessage = null;
            ret.loggingIn = false;
            return ret;

        case LOGIN.pending:
            ret = Object.assign({}, state);
            ret.loginErrorMessage = null;
            ret.loggingIn = true;
            return ret;

        case LOGIN.rejected:
            ret = Object.assign({}, state);
            ret.loggingIn = false;
            ret.loginErrorMessage = action.payload;
            return ret;

        case LOGIN.fulfilled:
            ret = Object.assign({}, state);
            ret.loggingIn = false;
            ret.user = action.payload;
            ret.loginErrorMessage = null;
            setUser(JSON.stringify(ret.user));

            action.onLoggedIn && action.onLoggedIn();

            return ret;

        case REGISTER_USER.pending:
            ret = Object.assign({}, state);
            ret.registerErrorMessage = null;
            ret.loggingIn = true;
            ret.registered = false;
            return ret;

        case REGISTER_USER.rejected:
            ret = Object.assign({}, state);
            ret.loggingIn = false;
            ret.registerErrorMessage = action.payload.data;
            return ret;

        case REGISTER_USER.fulfilled:
            ret = Object.assign({}, state);
            ret.loggingIn = false;
            ret.registerErrorMessage = null;
            ret.registered = true;
            action.onRegistered && action.onRegistered();
            return ret;

        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/home/home.duck.js